import { render, staticRenderFns } from "./List.vue?vue&type=template&id=b8c1ab0a&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=b8c1ab0a&prod&scoped=true&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&id=b8c1ab0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c1ab0a",
  null
  
)

export default component.exports